import api from "@shared/api/client";

const OBJECT_URL_TTL_MS = 60_000;

const invoicePdfUrl = async (invoiceId: number): Promise<string> => {
  const blob = await api.invoices.download(invoiceId);
  return window.URL.createObjectURL(blob);
};

const downloadInvoicePdf = async (invoiceId: number): Promise<void> => {
  let url = "";
  try {
    url = await invoicePdfUrl(invoiceId);
    const link = document.createElement("a");
    link.href = url;
    link.download = `invoice-${invoiceId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Failed to download invoice:", error);
  } finally {
    if (url) window.URL.revokeObjectURL(url);
  }
};

const openInvoicePdf = async (invoiceId: number): Promise<void> => {
  let url = "";
  try {
    url = await invoicePdfUrl(invoiceId);
    window.open(url, "_blank", "noopener,noreferrer");
  } catch (error) {
    console.error("Failed to open invoice:", error);
  }

  if (url) setTimeout(() => window.URL.revokeObjectURL(url), OBJECT_URL_TTL_MS);
};

export { downloadInvoicePdf, openInvoicePdf };
